export default __webpack_public_path__ + "static/media/action_history.fb74ef93.svg";